export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor_2240000-1709f57163359103e484c2993439cbf3.avif";